import React from 'react';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Button,
} from '@lb-classroom/ui';
import { X } from 'lucide-react';
import { useTranslation } from 'next-i18next';
import classnames from 'classnames';
import Checkbox from '@components/UI/atoms/form/Checkbox';
import ModalMessage from '@components/UI/organisms/ModalMessage';
import type { DeactivateConfirmationModalProps } from './deactivate-confirmation-modal.types';

export const DeactivateConfirmationModal = ({
  checked,
  isSubmitting,
  message,
  messageType,
  onCheckboxChange,
  onSubmit,
  onCancel,
}: DeactivateConfirmationModalProps) => {
  const { t } = useTranslation('common');
  const contentClass = classnames('', { loading: isSubmitting });

  return (
    <div className="max-w-sm mx-auto">
      <Card className="z-50">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle>{t('modals.deactivateConfirmation.title')}</CardTitle>
          <button type="button" className="modal-close" onClick={onCancel}>
            <span className="sr-only">Close</span>
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </CardHeader>
        <CardContent>
          <ModalMessage message={message} messageType={messageType} />
          <div className={contentClass}>
            <p
              dangerouslySetInnerHTML={{
                __html: t('modals.deactivateConfirmation.intro'),
              }}
            />
            <form method="post" className="login-form" onSubmit={onSubmit}>
              <div className="grid grid-cols-12 gap-2">
                <div className="col-span-12 flex items-center">
                  <Checkbox
                    id="confirm-deactivation-checkbox"
                    isChecked={checked}
                    updateHandler={onCheckboxChange}
                    wrapperClass="mr-2"
                  />
                  <label
                    htmlFor="confirm-deactivation-checkbox"
                    className="checkbox-text"
                  >
                    <span>
                      {t('modals.deactivateConfirmation.checkboxLabel')}
                    </span>
                  </label>
                </div>
              </div>
              <div className="control-group mb-4 mt-6">
                <Button
                  onClick={onCancel}
                  variant="outline"
                  className="float-left"
                  disabled={isSubmitting}
                  type="reset"
                >
                  {t('links.cancel')}
                </Button>
                <Button
                  variant="destructive"
                  className="float-right"
                  type="submit"
                  disabled={isSubmitting}
                  onClick={onSubmit}
                >
                  {t('links.deactivate')}
                </Button>
              </div>
            </form>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
